import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, registerUser, resetRegisterSuccess  } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaCamera } from "react-icons/fa";
import LoginImg from "../assets/images/login_image.jpg";
import SelectDropdown from "../components/comman/SelectDropdown";
import countryList from "react-select-country-list";
import CountryDropdown from "../components/comman/CountryDropdown";
import StateDropdown from "../components/comman/StateDropdown";
import CityDropdown from "../components/comman/CityDropdown";
import ProfileImg from "../assets/images/user.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const countries = countryList().getData();
  const [imagePreview, setImagePreview] = useState();
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const { loading, error, user, token, registerSuccess } = useSelector(
    (state) => state.auth
  );
  const [activeTab, setActiveTab] = useState("signin");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
    phone: "",
    gender: "",
    password: "",
    city: "",
    state: "",
    country: "",
    profile_picture: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(loginData));
  };

  const handleSignupSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", registerData.name);
    formData.append("email", registerData.email);
    formData.append("phone", registerData.phone);
    formData.append("gender", registerData.gender);
    formData.append("password", registerData.password);
    formData.append("country", registerData?.country?.countryName || "");
    formData.append("state", registerData?.state?.label || "");
    formData.append("city", registerData?.city?.label || "");
    if (registerData.profile_picture) {
      formData.append("profile_picture", registerData.profile_picture);
    }
    dispatch(registerUser(formData));
  };

  useEffect(() => {
    if (user && token && activeTab === "signin") {
      navigate("/");
    }
  }, [user, token, activeTab, navigate]);

  useEffect(() => {
    if (registerSuccess) {
      setActiveTab("signin");
      dispatch(resetRegisterSuccess());
    }
  }, [registerSuccess, dispatch]);

  return (
    <section className="login-section">
      <Container>
        <div className="login-box">
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="login-img">
                <img src={LoginImg} alt="login_img" className="img-fluid" />
              </div>
            </Col>

            <Col lg={6}>
              <Tabs
                id="login-tabs"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                {/* --- Sign In Tab --- */}
                <Tab eventKey="signin" title="Sign In">
                  <div className="signin-content">
                    <form onSubmit={handleLoginSubmit}>
                      <Row>
                        <Col md={12}>
                          <div className="form-group">
                            <label
                              htmlFor="signin-email"
                              className="form-label"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="signin-email"
                              value={loginData.email}
                              onChange={(e) =>
                                setLoginData({
                                  ...loginData,
                                  email: e.target.value,
                                })
                              }
                              placeholder="Enter your email"
                            />
                          </div>
                        </Col>

                        <Col md={12}>
                          <div className="form-group position-relative">
                            <label
                              htmlFor="signin-password"
                              className="form-label"
                            >
                              Password
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              id="signin-password"
                              value={loginData.password}
                              onChange={(e) =>
                                setLoginData({
                                  ...loginData,
                                  password: e.target.value,
                                })
                              }
                              placeholder="Enter your password"
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              className="hidden-text-check"
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="remember"
                              checked={loginData.remember}
                              onChange={(e) =>
                                setLoginData({
                                  ...loginData,
                                  remember: e.target.checked,
                                })
                              }
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="remember"
                            >
                              Remember me
                            </label>
                          </div>
                        </Col>

                        <Col md={6} className="text-md-end text-start">
                          <a href="#" className="text-decoration-none">
                            Forgot Password?
                          </a>
                        </Col>

                        {error && (
                          <Col md={12}>
                            <p className="text-danger mt-2">{error}</p>
                          </Col>
                        )}

                        <Col md={12}>
                          <button
                            type="submit"
                            className="submitbtn mt-3"
                            disabled={loading}
                          >
                            {loading ? "Signing In..." : "Sign In"}
                          </button>
                        </Col>

                        <Col md={12}>
                          <p className="text-center mt-3">
                            Don't have an account?
                            <a
                              href="#"
                              className="text-decoration-none"
                              onClick={(e) => {
                                e.preventDefault();
                                setActiveTab("signup");
                              }}
                            >
                              Sign Up
                            </a>
                          </p>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </Tab>

                {/* --- Sign Up Tab --- */}
                <Tab eventKey="signup" title="Sign Up">
                  <div className="signup-content">
                    <form onSubmit={handleSignupSubmit}>
                      <Row>
                        <Col md={12}>
                          <div className="form-group text-center mb-3">
                            <div className="position-relative d-inline-block mb-2">
                              <img
                                src={imagePreview || ProfileImg}
                                alt="Profile Preview"
                                className="img-thumbnail"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "50%",
                                  backgroundColor: "#f5f5f5",
                                }}
                              />
                              <div
                                className="camera-icon"
                                onClick={() =>
                                  document
                                    .getElementById("profile-image")
                                    .click()
                                }
                                style={{
                                  position: "absolute",
                                  bottom: "0",
                                  right: "0",
                                  backgroundColor: "var(--text-gray)",
                                  color: "var(--color-white)",
                                  borderRadius: "50%",
                                  height: "30px",
                                  width: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <FaCamera size={14} />
                              </div>
                            </div>

                            <input
                              type="file"
                              id="profile-image"
                              style={{ display: "none" }}
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setRegisterData({
                                    ...registerData,
                                    profile_picture: file,
                                  });
                                  setImagePreview(URL.createObjectURL(file));
                                }
                              }}
                            />
                            <label
                              htmlFor="profile-image"
                              className="form-label d-block"
                            >
                              Upload Profile
                            </label>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label htmlFor="signup-name" className="form-label">
                              Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="signup-name"
                              placeholder="Enter your name"
                              value={registerData.name}
                              onChange={(e) =>
                                setRegisterData({
                                  ...registerData,
                                  name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label
                              htmlFor="signup-email"
                              className="form-label"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="signup-email"
                              placeholder="Enter your email"
                              value={registerData.email}
                              onChange={(e) =>
                                setRegisterData({
                                  ...registerData,
                                  email: e.target.value,
                                })
                              }
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label
                              htmlFor="signup-phone"
                              className="form-label"
                            >
                              Phone
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="signup-phone"
                              placeholder="Enter your phone number"
                              value={registerData.phone}
                              onChange={(e) =>
                                setRegisterData({
                                  ...registerData,
                                  phone: e.target.value,
                                })
                              }
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group position-relative">
                            <label
                              htmlFor="signup-password"
                              className="form-label"
                            >
                              Password
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              id="signup-password"
                              placeholder="Enter your password"
                              value={registerData.password}
                              onChange={(e) =>
                                setRegisterData({
                                  ...registerData,
                                  password: e.target.value,
                                })
                              }
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              className="hidden-text-check"
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label
                              htmlFor="signup-gender"
                              className="form-label"
                            >
                              Gender
                            </label>
                            <SelectDropdown
                              options={genderOptions}
                              value={genderOptions.find(
                                (opt) => opt.value === registerData.gender
                              )}
                              onChange={(selected) =>
                                setRegisterData({
                                  ...registerData,
                                  gender: selected.value.toLowerCase(),
                                })
                              }
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <CountryDropdown
                            options={countries}
                            selectedCountry={registerData.country}
                            setSelectedCountry={(country) =>
                              setRegisterData({ ...registerData, country })
                            }
                          />
                        </Col>
                        <Col md={6}>
                          <StateDropdown
                            selectedCountry={registerData.country}
                            selectedState={registerData.state}
                            setSelectedState={(state) =>
                              setRegisterData({ ...registerData, state })
                            }
                          />
                        </Col>
                        <Col md={6}>
                          <CityDropdown
                            selectedCountry={registerData.country}
                            selectedState={registerData.state}
                            selectedCity={registerData.city}
                            setSelectedCity={(city) =>
                              setRegisterData({ ...registerData, city })
                            }
                          />
                        </Col>
                        {error && (
                          <Col md={12}>
                            <p className="text-danger mt-2">{error}</p>
                          </Col>
                        )}
                        <Col md={12}>
                          <button
                            type="submit"
                            className="submitbtn mt-3"
                            disabled={loading}
                          >
                            {loading ? "Registering..." : "Sign Up"}
                          </button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Login;
